import { ArrowSquareOut } from "@phosphor-icons/react";
import { Link, Text } from "@radix-ui/themes";

interface SourceLinkBlockProps {
  title: string;
  url: string;
  linkType?: string;
}

export function SourceLinkBlock({
  title,
  url,
  linkType,
}: SourceLinkBlockProps) {
  return (
    <Link
      data-testid="source-link-block"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      size="1"
      className="inline-flex items-center gap-1.5 rounded-md border border-puntt-neutral-gray-6 bg-puntt-neutral-gray-2 px-2.5 py-1 no-underline transition-colors hover:bg-puntt-neutral-gray-3"
    >
      {title}
      {linkType && (
        <Text as="span" size="1" className="text-puntt-neutral-gray-9">
          ({linkType})
        </Text>
      )}
      <ArrowSquareOut size={12} aria-hidden="true" />
    </Link>
  );
}
